<template>
 <div class="advantage">
  <div class="advantage-title advantage_box">畅图云</div>
  <div class="advantage-content advantage_box">
   <div class="advantage-content-card">
    <img src="../../assets/image/home/more.png" style="width: 66px; height: 66px; margin: 20px 0;" alt="" />
    <div class="advantage-content-card-title">多快好省</div>
    <div class="advantage-content-card-desc">产品支持零代码应用搭建服务，基于云原生、多租户、微服务等技术，能够实现智能化业务场景的快速搭建</div>
   </div>
   <div class="advantage-content-card">
    <img src="../../assets/image/home/autonomy.png" style="width: 66px; height: 66px; margin: 20px 0;" alt="" />
    <div class="advantage-content-card-title">自主可控</div>
    <div class="advantage-content-card-desc">产品国产研发，自主可控，支持信创软硬件环境</div>
   </div>
   <div class="advantage-content-card">
    <img src="../../assets/image/home/product.png" style="width: 66px; height: 66px; margin: 20px 0;" alt="" />
    <div class="advantage-content-card-title">产品完善</div>
    <div class="advantage-content-card-desc">产品体系丰富，一站式服务赋能“采集集成-数据管理-数据服务-设计建模-AI模型-可视化-报表分析”等全流程应用
    </div>
   </div>
   <div class="advantage-content-card">
    <img src="../../assets/image/home/service.png" style="width: 66px; height: 66px; margin: 20px 0;" alt="" />
    <div class="advantage-content-card-title">服务优质</div>
    <div class="advantage-content-card-desc">服务和运维多个能源集团业务系统；符合矿山业务需求，交付后用户可在此基础上实现自维护自开发
    </div>
   </div>
   <div class="advantage-content-card">
    <img src="../../assets/image/home/cloud.png" style="width: 66px; height: 66px; margin: 20px 0;" alt="" />
    <div class="advantage-content-card-title">云原生和私有部署</div>
    <div class="advantage-content-card-desc">深度结合容器技术，实现可伸缩与高可用；支持多云部署，自由选择云基础设施</div>
   </div>
  </div>
  <div class="advantage-content-mobile">
   <div class="advantage-content-card-mobile">
    <img src="../../assets/image/home/more.png" class="advantage-content-card-mobile-img" alt="" />
    <div class="advantage-content-card-mobile-content">
     <div class=" advantage-content-card-title">多快好省</div>
     <div class="advantage-content-card-desc">产品支持零代码应用搭建服务，基于云原生、多租户、微服务等技术，能够实现智能化业务场景的快速搭建</div>
    </div>
   </div>
   <div class="advantage-content-card-mobile">
    <img src="../../assets/image/home/autonomy.png" class="advantage-content-card-mobile-img" alt="" />
    <div class="advantage-content-card-mobile-content">
     <div class=" advantage-content-card-title">自主可控</div>
     <div class="advantage-content-card-desc">产品国产研发，自主可控，支持信创软硬件环境</div>
    </div>
   </div>
   <div class="advantage-content-card-mobile">
    <img src="../../assets/image/home/product.png" class="advantage-content-card-mobile-img" alt="" />
    <div class="advantage-content-card-mobile-content">
     <div class=" advantage-content-card-title">产品完善</div>
     <div class="advantage-content-card-desc">产品体系丰富，一站式服务赋能“采集集成-数据管理-数据服务-设计建模-AI模型-可视化-报表分析”等全流程应用
     </div>
    </div>
   </div>
   <div class="advantage-content-card-mobile">
    <img src="../../assets/image/home/service.png" class="advantage-content-card-mobile-img" alt="" />
    <div class="advantage-content-card-mobile-content">
     <div class=" advantage-content-card-title">服务优质</div>
     <div class="advantage-content-card-desc">服务和运维多个能源集团业务系统；符合矿山业务需求服务优质，交付后用户可在此基础上实现自维护自开发
     </div>
    </div>
   </div>
   <div class="advantage-content-card-mobile">
    <img src="../../assets/image/home/cloud.png" class="advantage-content-card-mobile-img" alt="" />
    <div class="advantage-content-card-mobile-content">
     <div class=" advantage-content-card-title">云原生和私有部署</div>
     <div class="advantage-content-card-desc">深度结合容器技术，实现可伸缩与高可用；支持多云部署，自由选择云基础设施</div>
    </div>
   </div>
  </div>
  <div class="advantage_box">
   <learnmore path="https://platform.mapaas.com/home" type="_blank" />
  </div>
 </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import learnmore from "@/components/learnmore.vue"
import { getFilterList } from "@/api/index"
import ScrollReveal from 'scrollreveal'
const dataList = ref([])
const technical = ref(null)
const boxRef = ref(null)

const getImgUrl = (item) => {
 if (item['picture-uploadab4e5456'] && item['picture-uploadab4e5456'].length > 0) {
  return item['picture-uploadab4e5456'][0].url
 } else {
  return ""

 }
}


const getData = async () => {
 let params = {
  page: 1,
  pageSize: 10,
  worksheetId: "6805abe1ec5e343d1c9826ae",
  sortField: "number7fea83d6",
  isAsc: true
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataList.value = res.data
 }
}

onMounted(() => {
 // getData()
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 200,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".advantage_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .advantage-content {
  display: none !important;
 }

 .advantage-content-mobile {
  display: block;

 }

 .advantage {
  height: 100% !important;
 }
}



@media screen and (min-width: 800px) {
 .advantage-content {
  display: flex !important;
 }

 .advantage-content-mobile {
  display: none;
 }


}

.advantage {
 width: 100%;
 height: 700px;
 background-color: rgba(247, 249, 255, 1);
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 font-family: 'PuHuiTi';
 padding-top: 20px;

}

.advantage-title {
 font-size: 36px;
 font-weight: 500;

}

.advantage-content {
 width: 100%;
 height: 294px;
 display: flex;
 align-items: center;
 justify-content: center;
 margin: 80px 0;
}

.advantage-content-card {
 width: 264px;
 height: 292px;
 background: url("../../assets/image/advantage_card.png");
 margin: 0 20px;
 display: flex;
 flex-direction: column;
 align-items: center;
 padding: 10px 20px;
}

.advantage-content-card-title {
 font-size: 18px;
 font-weight: 500;
 margin-bottom: 10px;
 color: rgba(0, 0, 0, 0.85);
}

.advantage-content-card-desc {
 font-size: 14px;
 font-weight: 400;
 color: #6b6b6b;
 line-height: 20px;
}

.advantage-content-card-mobile {
 height: 130px;
 display: flex;
 align-items: center;
 background: #fff;
 margin: 10px;
}

.advantage-content-card-mobile-img {
 width: 70px;
 height: 70px;
 margin-left: 20px;
}

.advantage-content-card-mobile-content {
 display: flex;
 flex-direction: column;
 margin-left: 20px;
 margin-right: 10px;
}
</style>